var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SectionProjects"},_vm._l((_vm.portfoliosFormated),function(portfolio){return _c('CardPortfolioLandowner',{key:portfolio.id,attrs:{"isShortSubtitle":"","portfolio":portfolio}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }